import { RegentsAssignmentAugCtrl } from './regents-assignment-aug.controller';

export const RegentsAssignmentAugComponent = {
  controller: RegentsAssignmentAugCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./regents-assignment-aug.html'),
};
